// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_QUf","cls2":"VideoPlayerMainContent-cls2_7tk VideoPlayerMainContent-cls1_QUf"};